<template>
  <Grid gtr="79px 1fr" class="bg-img-layout" :style="{ '--image-height': height }">
    <Grid gtc="1fr auto" content-items="center" class="text-heading-3 text-white bg-img-layout--title">
      <div>
        <slot name="title">
          <div v-if="linkToEntity && route" class="cursor-pointer" @click="$router.push(route)">
            {{ title }} <i class="far fa-link fa-1x" />
          </div>

          <span v-else>
            {{ title }}
            <HelpPageBtn v-if="page" :color="iconColor" :page="page" />
          </span>

          <slot name="after-title"></slot>
        </slot>
      </div>

      <Grid gaf="column" align-items="center" gap="18px">
        <slot name="actions-before"></slot>

        <template v-if="user">
          <SearchInput />

          <q-btn round flat dense to="/system-settings">
            <q-icon size="24px" color="white" name="settings"></q-icon>
            <LmTooltip anchor="bottom left" self="center right">Go to settings</LmTooltip>
          </q-btn>
        </template>

        <q-btn round flat dense @click="$router.absUrl(__guide.base)">
          <q-icon size="24px" color="white" name="help_outline"></q-icon>
          <LmTooltip anchor="bottom left" self="center right">Go to Help page</LmTooltip>
        </q-btn>

        <slot name="actions-after"></slot>
      </Grid>
    </Grid>

    <div class="bg-img-layout--page-content">
      <slot></slot>
    </div>
  </Grid>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
// Components
import SearchInput from '@components/SearchInput'
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'

export default {
  components: {
    SearchInput,
    HelpPageBtn
  },

  props: {
    height: {
      type: String,
      default: '139px'
    },

    title: String,
    linkToEntity: Boolean,
    route: Object,
    page: Object,
    iconColor: String
  },

  computed: {
    ...mapState({ user: state => state.user })
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

@include custom-scrollbar('.bg-img-layout');

.bg-img-layout {
  background-image: url('~@/assets/img/topbar-bg.jpg');
  background-repeat: no-repeat;
  background-attachment: local;
  background-size: 100% var(--image-height);
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: auto;

  &--title {
    padding: 10px 40px;

    ::v-deep i {
      font-size: 13px;
    }

    ::v-deep .editable-field-container.positioned-high {
      top: 3.7rem;
    }
  }

  &--page-content {
    padding: 0 20px 20px;
  }
}
</style>
